'use client';

import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { HeaderContext } from '../../../contexts/headerContext';
import { getCurrentOrganization, getOrganizationPropertiesByHost } from '../../../utils/helpers';
import { useUser } from '../../../contexts/ssr-user-context';
import { useMiscellaneousData } from '../../../contexts/ssr-miscellaneous-context';

export default function LoginButton({ handleSetLeftSidebar }) {
  const { miscellaneousData } = useMiscellaneousData();
  let organizationProperties;
  if (miscellaneousData?.hostname) {
    organizationProperties = getOrganizationPropertiesByHost(miscellaneousData.hostname);
  } else {
    organizationProperties = getCurrentOrganization();
  }
  const isNextIas = organizationProperties?.organizationName === 'nextias';

  const { setShowLogin } = useContext(HeaderContext);
  const { user } = useUser();
  const isLoggedIn = user?.id;
  const router = useRouter();
  const searchParams = useSearchParams();

  function domainBaseUrl() {
    return window.location.origin;
  }

  const handleRedirect = () => {
    if (searchParams.has('redirectTo')) return;

    const baseUrl = domainBaseUrl();
    const currentPath = window.location.pathname;

    const redirectTo = encodeURIComponent(`${baseUrl}${currentPath}`);
    const newUrl = `${currentPath}?redirectTo=${redirectTo}`;

    console.log('newUrl', newUrl);
    window.history.replaceState(null, '', newUrl);
  };

  const handleCleanUrl = () => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('redirectTo')) {
      url.searchParams.delete('redirectTo');
      const cleanUrl = url.pathname + url.search;
      window.history.replaceState(null, '', cleanUrl);
    }
  };

  useEffect(() => {
    handleCleanUrl();
  }, []);

  return (
    <>
      {isLoggedIn && (
        <button
          type="button"
          className={`${
            isNextIas
              ? 'border border-red-500 text-red-500 rounded-[6px]'
              : 'bg-[#0267b1] text-white mr-5'
          } font-semibold py-2 px-3 text-sm whitespace-nowrap`}
          onClick={() => router.push('/prep/home')}
        >
          Dashboard
        </button>
      )}

      {!isLoggedIn && (
        <button
          type="button"
          className={`${
            isNextIas
              ? 'border border-red-500 text-red-500 rounded-[6px]'
              : 'bg-[#0267b1] text-white'
          } font-semibold py-[0.375rem] px-[0.75rem] text-base whitespace-nowrap`}
          onClick={() => {
            setShowLogin(true);
            handleRedirect();
            if (handleSetLeftSidebar) {
              handleSetLeftSidebar(false);
            }
          }}
        >
          {isNextIas ? 'Login' : 'Login/Signup'}
        </button>
      )}
    </>
  );
}

LoginButton.propTypes = {
  handleSetLeftSidebar: PropTypes.func,
};
